;(function (angular, _) {
  'use strict'

  class ProductTypeListController {
    // DI
    $uibModal
    productTypeManager
    displayService
    snackService
    // Locals
    pagination
    productTypes = []
    loading = false

    constructor (
      // Angular
      // Libs
      $uibModal,
      // Managers
      ProductTypeManager,
      // Services
      DisplayService, PaginationModel, SnackService
      // Const
      // Resolved
    ) {
      this.$uibModal = $uibModal
      this.productTypeManager = ProductTypeManager
      this.displayService = DisplayService
      this.snackService = SnackService
      this.pagination = PaginationModel.getRaw({ perPage: 5 })
    }

    $onInit () {
      this.getList()
    }

    $onDestroy () {
      // Retire le watcher $rootScope de la pagination créée par getRaw()
      this.pagination.destroy()
    }

    getList () {
      this.loading = true
      const query = this.productTypeManager.query(this.pagination.toQueryOptions())
      return this.productTypeManager.get(query).then(({ data, meta }) => {
        this.productTypes = data
        this.pagination.totalElements = meta.total
      }).finally(() => {
        this.loading = false
      })
    }

    editProductType (productType) {
      return this.$uibModal.open({
        size: 'lg',
        bindToController: true,
        resolve: {
          action: function () { return 'modifier' },
          type: function () { return angular.copy(productType) }
        },
        templateUrl: '/app/modules/preferences/accounting/create-product-type.html',
        controller: 'CreateProductTypeController',
        controllerAs: 'ctrl'
      }).result.then((type) => {
        return type.save()
      }).then(() => {
        this.snackService.snack({
          text: 'Type de produit sauvegardé !',
          delay: 5000
        })
        this.pagination.currentPage = 0
        return this.getList()
      })
    }

    deleteProductType (productType) {
      return this.displayService.confirmDeletion().then(() => {
        return productType.archive()
      })
        .then(() => {
          this.snackService.snack({
            text: 'Type de produit supprimé !',
            delay: 5000
          })
          this.pagination.currentPage = 0
          return this.getList()
        })
    }

    createProductType () {
      return this.$uibModal.open({
        size: 'lg',
        bindToController: true,
        resolve: {
          action: function () { return 'Créer' },
          type: () => {
            return this.productTypeManager.create()
          }
        },
        templateUrl: '/app/modules/preferences/accounting/create-product-type.html',
        controller: 'CreateProductTypeController',
        controllerAs: 'ctrl'
      }).result.then((type) => {
        return type.save()
      }).then(() => {
        this.snackService.snack({
          text: 'Type de produit créé !',
          delay: 5000
        })
        this.pagination.currentPage = 0
        return this.getList()
      })
    }
  }

  ProductTypeListController.$inject = [
    // Angular
    // Libs
    '$uibModal',
    // Managers
    'ProductTypeManager',
    // Services
    'DisplayService', 'PaginationModel', 'SnackService'
    // Const
    // Resolved
  ]

  angular.module('kilo.routes.preferences')
    .component('productTypeList', {
      bindings: {},
      templateUrl: '/app/modules/preferences/ledger/components/product-type-list/product-type-list.template.html',
      controller: ProductTypeListController
    })
})(window.angular, window._)
